import BaseModel from "../../BaseModal"
import { getDateWithTime } from "../../utils";
import { FlexWrapperCenter, GapView, LineView } from "../../styles/WrapperStyles";
import styled, { css } from "styled-components";
import './Modal.css';
import React from "react";

const ParentDiv = styled.div`
  width: 1100px;
  height: 339px;
  border-radius: 20px;
`;

const TextView = styled.p`
  font-family: 'Gilory-Semi';
  font-size: 18px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #484848;
  text-align: center;
  ${props =>
        props.small &&
        css`
      font-size: 16px;
    `}
`;

const TitleView = styled.div`
  font-family: 'Gilroy-Bold';
  font-size: 20px;
  font-weight: 800;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #484848;
  text-align: center;
`;

const DeviceInfoModal = (props) => {
    return (
        <BaseModel closeModal={props.closeModal}>
            <ParentDiv style={{ width: '100%', padding: '20px' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                        <tr>
                            <th style={{ border: '1px solid #ddd', padding: '8px' }}>Device Type</th>
                            <th style={{ border: '1px solid #ddd', padding: '8px' }}>Model</th>
                            <th style={{ border: '1px solid #ddd', padding: '8px' }}>Version</th>
                            <th style={{ border: '1px solid #ddd', padding: '8px' }}>Upgrade Time</th>
                        </tr>
                    </thead>
                    <tbody>
                        {props.profile.profile_data.app_versions_list.map((item, pos) => (
                            <React.Fragment key={pos}>
                                <tr>
                                    <td rowSpan={item.version.length} style={{ border: '1px solid #ddd', padding: '8px' }}>{item.device_type}</td>
                                    <td rowSpan={item.version.length} style={{ border: '1px solid #ddd', padding: '8px' }}>{item.device_model}</td>
                                    <td style={{ border: '1px solid #ddd', padding: '8px' }}>{item.version[0].version}</td>
                                    <td style={{ border: '1px solid #ddd', padding: '8px' }}>{item.version[0].created_at}</td>
                                </tr>
                                {item.version.slice(1).map((version, index) => (
                                    <tr key={index}>
                                        <td style={{ border: '1px solid #ddd', padding: '8px' }}>{version.version}</td>
                                        <td style={{ border: '1px solid #ddd', padding: '8px' }}>{version.created_at}</td>
                                    </tr>
                                ))}
                            </React.Fragment>
                        ))}
                    </tbody>
                </table>
            </ParentDiv>
        </BaseModel>
    );
}





export default DeviceInfoModal